const styles = () => ({
	description: {
		margin: '24px 5% 24px',
		maxWidth: '87.5%',

		fontSize: '18px',
		fontStyle: 'normal',
		fontWeight: 300,
		lineHeight: '24px',

		color: '#444444',

		'@global h1': {
			marginBottom: '16px'
		}
	},
	mobileDescription: {
		visibility: 'hidden',
		margin: '24px 5% 24px',
		maxWidth: '87.5%',

		textAlign: 'justify',
		fontSize: '18px',
		fontStyle: 'normal',
		fontWeight: 300,
		lineHeight: '24px',

		color: '#444444',
		'& p': {
			wordWrap: 'break-word'
		}
	},
	'@media (max-width: 1020px)': {
		desktopDescription: {
			visibility: 'hidden'
		},
		mobileDescription: {
			display: 'visible'
		}
	}
});

export default styles;




// WEBPACK FOOTER //
// ./src/client/components/main/files/video/styles.js